import React, {useState} from 'react';
import {Link, useNavigate} from 'react-router-dom';
import {loginUser} from '../api';
import './Auth.css';

function LoginPage({onLoginSuccess}) {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [errorMsg, setErrorMsg] = useState('');
    const navigate = useNavigate();

    const handleLogin = async (event) => {
        event.preventDefault();
        setErrorMsg('');
        const res = await loginUser(username, password);

        if (res.token) {
            onLoginSuccess(res.token);
            navigate('/');
        } else {
            setErrorMsg(res.message || 'Ошибка входа');
        }
    };

    return (
        <section className="auth-page">
            <div className="auth-card panel">
                <p className="page-kicker">Аккаунт</p>
                <h1>Вход в My Shop</h1>

                <form className="auth-form" onSubmit={handleLogin}>
                    <div className="field">
                        <label htmlFor="login-username">Имя пользователя</label>
                        <input
                            id="login-username"
                            type="text"
                            autoComplete="username"
                            placeholder="Введите логин"
                            value={username}
                            onChange={event => setUsername(event.target.value)}
                        />
                    </div>

                    <div className="field">
                        <label htmlFor="login-password">Пароль</label>
                        <input
                            id="login-password"
                            type="password"
                            autoComplete="current-password"
                            placeholder="Введите пароль"
                            value={password}
                            onChange={event => setPassword(event.target.value)}
                        />
                    </div>

                    {errorMsg && <div className="notice notice-error auth-message">{errorMsg}</div>}

                    <button className="btn btn-primary auth-btn" type="submit">
                        Войти
                    </button>
                </form>

                <div className="switch-auth">
                    <span>Нет аккаунта?</span>
                    <Link to="/register">Зарегистрироваться</Link>
                </div>
            </div>

            <aside className="auth-showcase" aria-label="Популярные товары">
                <div className="auth-product auth-product-main">
                    <img src="/images/iphone15black.png" alt="Iphone15 Black" />
                    <strong>Iphone15</strong>
                    <span>от 99 999 руб.</span>
                </div>
                <div className="auth-product-row">
                    <div className="auth-product">
                        <img src="/images/samsung.png" alt="Galaxy Ultra 24" />
                        <strong>Galaxy Ultra 24</strong>
                    </div>
                    <div className="auth-product">
                        <img src="/images/xiaomi14.png" alt="Xiaomi 14" />
                        <strong>Xiaomi 14</strong>
                    </div>
                </div>
            </aside>
        </section>
    );
}

export default LoginPage;
